<template>
  <nav class="pagination">
    <div
      v-if="+result.pageNumber < result.pageCount && result.addMore"
      class="pagination__add-more"
      @click="handlerAddMore"
    >
      {{ result.addMore }} {{ result.pageSize }}
    </div>
    <div
      v-else-if="+result.pageNumber < result.pageCount && messages?.title"
      class="pagination__add-more"
      @click.prevent="handlerAddMore"
    >
      {{ messages?.title }} {{ result.pageSize }}
    </div>
    <div v-if="obData.params.showPagination" v-show="isShow" class="pagination__nav">
      <div v-for="item in createPaginationArray">
        <div
          v-if="typeof item === 'number'"
          :class="{ pagination__item_active: item == result.pageNumber }"
          class="pagination__item"
          @click="handlerClick(item)"
        >
          {{ item }}
        </div>
        <div v-else class="pagination__item">
          {{ item }}
        </div>
      </div>
    </div>
  </nav>
</template>
<script>
export default {
  name: 'Pagination',
  props: {
    result: {
      type: Object,
      default: () => ({
        pagingKey: 'PAGEN_1',
        pageCount: 3,
        pageNumber: 3,
        pageSize: 2,
      }),
    },
    messages: {
      type: Object,
    },
    isShow: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      obData: {
        params: {
          showPagination: true,
        },
        maxCounter: 5,
      },
    };
  },
  computed: {
    createPaginationArray() {
      try {
        const paginationArray = [];
        const maxCounter =
          +this.result.pageNumber + +this.obData.maxCounter - +this.result.pageNumber;
        const startCount = +this.result.pageNumber === 1 ? 1 : +this.result.pageNumber - 1;

        // добавляем переход на первую страницу
        if (startCount >= 2) {
          paginationArray.push(1);
        }
        if (startCount >= 3) {
          paginationArray.push('...');
        }

        // создаем оставшуюся часть для пагинации
        for (let i = startCount; i <= +this.result.pageCount; i++) {
          if (i < maxCounter + startCount - 1) {
            paginationArray.push(i);
          } else if (i === maxCounter + startCount - 1) {
            if (+this.result.pageCount - +this.result.pageNumber + 2 > +this.obData.maxCounter) {
              paginationArray.push('...');
            }
            paginationArray.push(this.result.pageCount);
          }
        }
        return paginationArray;
      } catch (err) {
        console.error(err);
        return [];
      }
    },
  },
  methods: {
    scrollTop() {
      const scrollToElement = document.querySelector('.pagination-scroll-js');
      if (scrollToElement) {
        App.helpers.scrollPageTo(scrollToElement.offsetTop - 60);
      }
    },
    async handlerClick(item) {
      const { pageNumber, pageCount, pagingKey } = this.result;

      if (item == 0 || pageNumber == item || pageCount < item || typeof item !== 'number') return;

      const query = {
        ...this.$route.query,
        [pagingKey]: item,
      };

      await this.$router.replace({ path: this.$route.path, query });

      this.$emit('change', this.$route.fullPath);
      this.scrollTop();
    },
    async handlerAddMore() {
      const { pageNumber, pagingKey } = this.result;

      const query = {
        ...this.$route.query,
        [pagingKey]: +pageNumber + 1,
      };

      await this.$router.replace({ path: this.$route.path, query });

      this.$emit('addMore', this.$route.fullPath);
    },
  },
};
</script>

<style lang="scss">
.pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  padding: 24px 0;
  font-weight: 500;
  font-size: rem(14);
  letter-spacing: 0.08em;
  @include point-md {
    padding: 40px 0;
  }
  &__add-more {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 48px;
    background: var(--background-colour-primary);
    padding: 0 24px;
    overflow: hidden;
    white-space: nowrap;
    text-transform: uppercase;
    color: var(--text-colour-secondary);
    margin-bottom: 24px;
    @include point-md {
      margin-bottom: 40px;
    }
    &:hover {
      cursor: pointer;
    }
  }
  &__nav {
    display: flex;
    align-items: center;
  }
  &__item {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 1px solid transparent;
    color: #757575;
    &:not(:last-child) {
      margin-right: 8px;
    }
    &:hover {
      cursor: pointer;
    }
    &_active {
      border-color: var(--border-colour-primary);
      color: var(--text-colour-secondary);
    }
  }
}
</style>
